import React from 'react';
import {
    Pagination,
    List,
    Datagrid,
    TextField,
    DateField,
    NumberField,
    sanitizeListRestProps,
    TopToolbar} from 'react-admin';
import OrderListExportForm from './OrderListExportForm';
import { Box } from '@mui/material';
import { stripedDataGridSx } from '../styles/dataGridStyles';

const OrderPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

const OrderListActions = (props) => {
  const {
    exporter,
    filters,
    maxResults,
    setFilters,
    ...rest
  } = props;
  return (
    <TopToolbar {...sanitizeListRestProps(rest)}>
      <Box display="flex" justifyContent="flex-end" width="100%">
        <OrderListExportForm />
      </Box>
      <Box display="flex" justifyContent="flex-end" width="100%">
        <OrderPagination />
      </Box>
    </TopToolbar>
  );
};

export const OrderListExport = props => {
    return (
        <List
            sort={{ field: 'Order_Num', order: 'DESC' }}
            perPage={100}
            pagination={<OrderPagination />}
            bulkActionButtons={false}
            actions={<OrderListActions sx={{ paddingTop: '0px', display: 'block' }}/>}
            {...props}
        >
            <Datagrid sx={stripedDataGridSx}>
                <TextField label="Order Number" source="Order_Num" />
                <TextField source="Customer_Name" />
                <TextField source="Product_Name" />
                <NumberField label="QTY Loaded" source="Qty_Loaded" />
                <TextField source="Product_Units" />
                <TextField source="Pickup_Location" />
                <DateField label="Delivery Date" source="Delivery_Date" sortable={false} />
            </Datagrid>
        </List>
    );
}
